export default __webpack_public_path__ + "static/media/Screenshot_2.61497b6b.png";